module.exports = __webpack_public_path__ + "img/unita_mobili.fadd84e9.png";